<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class=" d-flex align-items-center">
        <h5 class="mb-0 text-primary"><i class="fas fa-money-bill-wave text-primary"></i> Fees</h5>
      </div>
      <hr>
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Name<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Name">
        </div>
        <div class="col-md-3">
          <label class="form-label">Amount<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="number" class="form-control form-control-sm" v-model="Obj.Amount">
        </div>
        <div class="col-md-3">
          <label class="form-label">Description<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Description">
        </div>
        <div class="col-md-9 text-end">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()"><i class="fa fa-save"></i> Save</button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <div class="col-12">
        <div class="row">
          <div class="col-md-9 table-responsive">
           <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
            <DataTable  v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />

          </div>

        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.Name" @delRecord="delRecord" @closeModal="delObj.Name = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
  const  Obj = ref( {Name: "", Amount: "", Description: "", })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Name', key: 'Name', },
  { label: 'Amount', key: 'Amount' },
  { label: 'Description', key: 'Description' }
]);
const handleEdit = (row) => {
    Obj.value = { ...row }
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const rows=ref([])
const  save =async() => {
      const fields = {
        Name: { value: Obj.value.Name, validators: [isRequired], },
        Amount: { value: Obj.value.Amount, validators: [isRequired], },
        Description: { value: Obj.value.Description, validators: [isRequired], },
      };
  const idx = rows.value.findIndex( (item) => item.Name.toLowerCase() === Obj.value.Name.toLowerCase() && item._id !== Obj.value._id );
  if (idx >= 0) {
    msgObj.value = { msg: "Fee Type already exists.", role: "danger", show: true };
    return;
  }
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/Fees${url}`, Obj.value)
          .then(() => {
          loadData();
            reset();
            msgObj.value = { msg: `Fees ${msg} Successfuly`, role: "success", show: true, };
           
          })
          .catch((error) => { console.log(error); });
      }
    }
    const reset =async () => {
      Obj.value = { Name: "", Amount: "", Description: "", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
    }
     const progress = ref(0)
    const loadData =async () => {
          let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      await api.get('/Fees/all') .then((response) => { rows.value = response.data.map((item, i) => ({ ...item, Sno: i + 1 }));  
      progress.value = 0
      clearInterval(progressInterval)
    });
    }
   const delRecord =async () => {
      await api.delete(`/Fees/${delObj.value._id}`)
        .then(() => {
          loadData();
          delObj.value={};
          msgObj.value = { msg: "Fees Deleted Successfuly.", role: "danger", show: true, };
        });
    }
     onMounted(() => { loadData() })
</script>